/**
 * Entry point for webpack, it declares all the libraries and attach the objects on the window
 */
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import _ from 'lodash';
import Bowser from 'bowser';
import observe from 'Utils/observe';
import CookiesPolicyHandler from './libs/cookies.policy.handler';

try {
	window._ = _;
	window.$ = window.jQuery = $;
	window.XRegExp = require('xregexp');
}
catch (e) {
	console.error('lnd.js', e);
}

require('bootstrap');
require('jquery-validation');

const parseUrl = (url) => {

	if (typeof url === 'string') {
		let anchor = document.createElement('a');
		anchor.href = url;
		return anchor;
	}

	return {};
};

((easymarkets) => {

	const browser = Bowser.getParser(window.navigator.userAgent);

	const ApiUrl = (easymarkets.data.jsapi_url || '').replace(/^(http:)*\/\//, 'https://');
	const StaticUrl = (easymarkets.data.static_data_url || '').replace(/^(http:)*\/\//, 'https://');
	const PlatformType = browser.getPlatformType(true) || 'desktop';

	const ApiIds = {
		desktop: 'CA7D0F97-F865-4D89-9983-409E5EE5DDF3',
		tablet: '0A121E99-D3A7-4E0C-8159-383BC90443B1',
		mobile: '63564FEC-2916-494E-A543-EFEE8DE4FBD5'
	};

	/**
	 * Replicate easymarkets api settings from main site
	 *
	 * @todo - would be better to import em api lib
	 */
	easymarkets.api = {
		settings: {
			apiId: ApiIds[PlatformType],
			apiUrl: ApiUrl,
			apiCors: window.location.hostname !== parseUrl(ApiUrl).hostname,
			staticUrl: StaticUrl
		}
	};

	window.addEventListener('load', () => {

		// Prompt for cookies consent, if needed
		const cookiesPolicyHandler = new CookiesPolicyHandler();
		cookiesPolicyHandler.init();

		const lazyImages = document.querySelectorAll('img[data-src]');

		if (lazyImages.length) {

			observe(lazyImages, (image) => {

				const src = image.getAttribute('data-src');

				if (src) {

					image.onload = () => {
						image.style.opacity = 1;
						image.style.filter = 'alpha(opacity=100)';
					};

					image.src = src;
					image.removeAttribute('data-src');
				}
			});
		}

	}, {
		once: true
	});

})(
	window.easymarkets
);
